<template>
    <div class="app-container">
        <div class="app-left">
            <div class="app-header">
                <div class="app-filter-wrapper">
                    <input class="filter-search-input" type="text" placeholder="Buscar..." />
                </div>
            </div>
            <div class="app-left-content">
                <router-view />
            </div>
        </div>
        
    </div>
</template>
<script setup>
import { onMounted } from 'vue';
// Efecto para las animaciones
onMounted(() => {
    const listItems = document.querySelectorAll(".fadeIn");
    const appBoxes = document.querySelectorAll(".app-box");

    listItems.forEach((listItem, index) => {
        listItem.style.animationDelay = `${index * 0.2}s`;
    });

    appBoxes.forEach((appBox, index) => {
        appBox.style.animationDelay = `${index * 0.1}s`;
    });
});
</script>

<style src="../styles/mainLayout.css"></style>